/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_preview_button_more_actions24 = /** @type {(inputs: {}) => string} */ () => {
	return `More actions`
};

const fr_preview_button_more_actions24 = /** @type {(inputs: {}) => string} */ () => {
	return `Plus d'actions`
};

const de_preview_button_more_actions24 = /** @type {(inputs: {}) => string} */ () => {
	return `Weitere Aktionen`
};

const es_preview_button_more_actions24 = /** @type {(inputs: {}) => string} */ () => {
	return `Más acciones`
};

const it_preview_button_more_actions24 = /** @type {(inputs: {}) => string} */ () => {
	return `Altre azioni`
};

const ar_preview_button_more_actions24 = /** @type {(inputs: {}) => string} */ () => {
	return `مزيد من الإجراءات`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const preview_button_more_actions24 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.preview_button_more_actions24(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("preview_button_more_actions24", locale)
	if (locale === "en") return en_preview_button_more_actions24(inputs)
	if (locale === "fr") return fr_preview_button_more_actions24(inputs)
	if (locale === "de") return de_preview_button_more_actions24(inputs)
	if (locale === "es") return es_preview_button_more_actions24(inputs)
	if (locale === "it") return it_preview_button_more_actions24(inputs)
	return ar_preview_button_more_actions24(inputs)
};
export { preview_button_more_actions24 as "PREVIEW_BUTTON_MORE_ACTIONS" }